import { faCalendarClock } from "@fortawesome/pro-regular-svg-icons/faCalendarClock";
import { Stack, Typography } from "@mui/material";
import { MprcText } from "components";
import { EnrollmentViewDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import LibUtils from "lib/LibUtils";
import { useTranslation } from "react-i18next";
import { MprcCardCourseIcon } from "views/lms/student/EnrollmentView/Course/ContentComponents/common/CourseViewComponents";

interface IProps extends React.PropsWithChildren {
    enrollment: EnrollmentViewDto;
}

/////////////////////////////////////////////////////////////////////////////////////

export const TrainingDueDate = (props: IProps) => {

    const { enrollment, children } = props;
    const { t } = useTranslation("lms");

    ///
    const RenderMissingDays = (date: Date) => {

        const diffDays = LibUtils.diffDays(new Date(), date);

        return (
            <>
                &nbsp;&mdash;&nbsp;
                {
                    diffDays == 0
                        ? <strong>{t("shared:Literal.Today").toUpperCase()}</strong>
                        : <strong>{t("Student.EnrollmentView.MissingDueDaysText", { count: diffDays })}</strong>
                }
            </>
        );
    };

    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    return (
        <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent={"flex-start"}>
            <MprcCardCourseIcon icon={faCalendarClock} />
            <div>
                {
                    enrollment.dueDate == null
                        ? (
                            <Typography variant="subtitle1" component="p" color="muted" textTransform="uppercase">
                                {t("Student.EnrollmentView.WithoutDueDateText")}
                            </Typography>
                        )
                        : enrollment.isDelayed
                            ? (
                                <>
                                    <Typography
                                        variant={"body2"}
                                        fontWeight="bold"
                                        component="p"
                                        textTransform="uppercase"
                                        color={"error"}
                                    >
                                        {
                                            enrollment.expireDate
                                                ? t("Student.EnrollmentView.DueDateExpiringText")
                                                : t("Student.EnrollmentView.DueDateOverdueText")
                                        }
                                    </Typography>
                                    {
                                        enrollment.expireDate &&
                                        <Typography variant="body2" component="p">
                                            <MprcText color={"error"}>
                                                {Formaters.performaDate(enrollment.expireDate, { dayOfWeek: true, preposition: "none" })}
                                                {RenderMissingDays(enrollment.expireDate)}
                                            </MprcText>
                                        </Typography>
                                    }
                                </>
                            )
                            : (
                                <>
                                    <Typography
                                        variant={"body2"}
                                        component="p"
                                        textTransform="uppercase"
                                        color={"muted"}
                                    >
                                        {t("Student.EnrollmentView.DueDateExpandedText")}
                                    </Typography>
                                    <Typography variant="body2" component="p">
                                        <MprcText color="warning">
                                            {Formaters.performaDate(enrollment.dueDate, { dayOfWeek: true, preposition: "none" })}
                                            {RenderMissingDays(enrollment.dueDate)}
                                        </MprcText>
                                    </Typography>
                                </>
                            )
                }
                {children}
            </div>
        </Stack>
    );
};
